import { Injectable } from "@angular/core";

@Injectable()
export class Handle {

    getError(element) {
        if (element === 'mail') {
          return "Debe ingresar un correo válido. ";
        }else if (element === 'telefono') {
          return "Debe ingresar un teléfono válido. ";
        }
         else if (element.hasError('required')) {
          return "Campo requerido";
        } else if (element.hasError('maxlength')) {
          return "Longitud maxima de " + element.errors.maxlength.requiredLength + " caracteres";
        } else if (element.hasError('minlength')) {
          return "Longitud mínima de " + element.errors.minlength.requiredLength + " caracteres";
        } else if (element.hasError('matDatepickerMin')) {
          return "La fecha debe ser mayor al dia de hoy";
        } else if (element.hasError('min')) {
          return "Valor mínimo de " + element.errors.min.min;
        } else if (element.hasError('max')) {
          return "Valor máximo de " + element.errors.max.max;
        } 
      }
}